import { Box, Card, CardMedia, Grid, Modal, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import images from '../data/gallery.json'; // Import the JSON file

const imageFolderPath = `/images/gallery/`;

function Gallery() {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [shuffledImages, setShuffledImages] = useState([]);

  const handleOpen = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentIndex(null);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!open) return;

      if (event.key === 'ArrowRight') {
        // Navigate to the next image
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      } else if (event.key === 'ArrowLeft') {
        // Navigate to the previous image
        setCurrentIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
      } else if (event.key === 'Escape') {
        // Close the modal
        handleClose();
      }
    };
    // Attach keydown listener when the modal is open
    if (open) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      // Cleanup the event listener
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  useEffect(() => {
    // Function to shuffle the images array
    const shuffleArray = (array) => {
      let shuffled = array.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };

    setShuffledImages(shuffleArray(images));
  }, []);

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ marginBottom: 4 }}>
        Gallery
      </Typography>
      <Grid container spacing={3}> {/* Increased spacing between images */}
        {shuffledImages.map((image, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                transition: 'transform 0.2s ease-in-out',
                '&:hover': { transform: 'scale(1.05)' },
              }}
              onClick={() => handleOpen(index)}
            >
              <CardMedia
                component="img"
                image={`${imageFolderPath}${image}?v=${Date.now()}`} // Cache-busting
                alt={`Gallery Image ${index + 1}`}
                sx={{
                  width: '100%',
                  height: 'auto', // Maintain aspect ratio
                  cursor: 'pointer',
                  display: 'block', // Ensures the image is visible
                }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Lightbox Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            maxWidth: '90%',
            maxHeight: '90%',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', // Ensure the image is centered
            width: '95vw',
          }}
        >
          {currentIndex !== null && (
            <img
              src={`${imageFolderPath}${shuffledImages[currentIndex]}`}
              alt={`Gallery ${currentIndex + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain', // Ensures the image fits within the modal
                display: 'block', // Removes inline `img` element whitespace
              }}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
}

export default Gallery;
